import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/myaeon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-476ab242")

_pushScopeId("data-v-476ab242")
const _hoisted_1 = { class: "main redirect-component" }
const _hoisted_2 = { class: "redirect__flex-container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  style: {"margin-bottom":"20px","width":"100%","height":"auto","display":"block"}
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_spin = _resolveComponent("a-spin")
  const _component_a_result = _resolveComponent("a-result")
  const _component_a_card = _resolveComponent("a-card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_a_card, { style: {"width":"100%","max-width":"400px","margin":"0 auto"} }, {
        default: _withId(() => [
          _hoisted_3,
          _createVNode(_component_a_result, {
            status: "info",
            title: "Redirecting...",
            "sub-title": "You will be redirected to the home page in a few seconds."
          }, {
            extra: _withId(() => [
              _createVNode(_component_a_spin, { size: "large" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
})